<template>
  <div class="producer-settings">
    <div class="form-item">
      <input
        type="range"
        :min="minSellingPrice"
        :max="maxSellingPrice"
        :step="sellingPriceStepSize"
        v-model="nextDefaultSellingPrice"
        @input="updateLocalNextDefaultSellingPrice"
        ref="sellingPrice"
      />

      <div class="default-selling-price">
        <div class="default-selling-price__label">Aktuell (netto)</div>
        <output class="default-selling-price__value">
          {{ formatPowerPrice(defaultSellingPrice) }}
        </output>
      </div>

      <div class="default-selling-price" v-if="nextDefaultSellingPrice">
        <div class="default-selling-price__label">
          {{ nextDefaultSellingPriceLabel }} (netto)
        </div>
        <output class="default-selling-price__value">
          {{ formatPowerPrice(nextDefaultSellingPrice) }}
        </output>
      </div>
    </div>

    <div :class="actionsClasses">
      <a class="settings-actions__cancel" @click="cancel()">abbrechen</a>

      <LinkButton
        type="small"
        icon-right="Arrow"
        form="defaultSellingPrice"
        :text="str('global.save')"
        :extra-classes="['button--primary', 'settings-actions__save']"
        @click.native="saveDefaultSellingPrice"
      />
    </div>
  </div>
</template>

<script>
  import LinkButton from '@/components/LinkButton'
  import util from '@/js/Util'

  export default {
    name: 'producer-settings',
    components: {
      LinkButton,
    },
    data() {
      return {
        nextDefaultSellingPrice: 0,
        originalNextDefaultSellingPrice: 0,
        settingsChanged: false,
      }
    },
    mounted() {
      this.nextDefaultSellingPrice = this.nextDefaultSellingPriceFromStore
      this.originalNextDefaultSellingPrice = this.nextDefaultSellingPriceFromStore
    },
    computed: {
      minSellingPrice: function () {
        return this.$store.getters.minDefaultSellingPrice
      },
      maxSellingPrice: function () {
        return this.$store.getters.maxDefaultSellingPrice
      },
      sellingPriceStepSize: function () {
        return this.$store.getters.sellingPriceStepSize
      },
      defaultSellingPrice: function () {
        return this.$store.getters.defaultSellingPrice
      },
      nextDefaultSellingPriceFromStore: function () {
        return this.$store.getters.nextDefaultSellingPrice
      },
      nextDefaultSellingPriceLabel: function () {
        let date = this.$store.getters.nextDefaultSellingPriceDate
        if (this.settingsChanged) {
          return this.str('efriends.nextPriceLabel')
        }
        return `Ab ${date ? util.formatPriceDate(date) : false}`
      },
      actionsClasses: function () {
        let classes = ['settings-actions']
        if (this.settingsChanged) {
          classes.push('settings-actions--visible')
        }
        return classes.join(' ')
      },
    },
    methods: {
      updateLocalNextDefaultSellingPrice(event) {
        this.nextDefaultSellingPrice = parseFloat(event.target.value)
        const priceChanged =
          this.nextDefaultSellingPrice !==
          this.$store.getters.nextDefaultSellingPrice
        this.settingsChanged = priceChanged
      },
      saveDefaultSellingPrice: async function () {
        if (!this.settingsChanged) {
          return false
        }
        const newPrice = this.nextDefaultSellingPrice
        await this.$store.dispatch('saveDefaultSellingPrice', newPrice)
        this.settingsChanged = false
      },
      cancel: function () {
        this.nextDefaultSellingPrice = this.originalNextDefaultSellingPrice
        this.settingsChanged = false
      },
    },
    watch: {
      nextDefaultSellingPriceFromStore: function (newValue) {
        this.nextDefaultSellingPrice = newValue
      },
    },
  }
</script>

<style lang="scss">
  .producer-settings {
  }

  .default-selling-price {
    display: inline-block;
    margin-right: spacer(2);

    &__value {
      font-size: $font-size-lg;
    }
  }

  .settings-actions {
    display: flex;
    justify-content: flex-end;
    max-height: 0;
    overflow: hidden;
    transition: $transition-base;
    align-items: center;

    &--visible {
      max-height: 200px;
    }

    &__cancel {
      cursor: pointer;
      margin-right: spacer(1);
    }
  }
</style>
